module.exports = __webpack_public_path__ + "img/20191128170642360截图20191128162638656.cc828e61.jpg";